import type { HTMLAttributes } from 'react';
import { useState } from 'react';
import { pickCss } from '@/shared/lib/css-utils';
import css from './avatar.module.scss';

type AvatarSize = 'sm' | 'md' | 'lg' | 'xl';
type AvatarColor = 'indigo' | 'violet' | 'pink' | 'green' | 'amber';

const avatarColors: AvatarColor[] = [
  'indigo',
  'violet',
  'pink',
  'green',
  'amber',
];

type AvatarProps = HTMLAttributes<HTMLDivElement> & {
  size?: AvatarSize;
  initials: string;
  // Optional photo URL. Falls back to the coloured initials circle when absent
  // or when the image fails to load.
  src?: string;
};

const avatarCss = pickCss(css, css.root);

export const Avatar = ({
  size = 'md',
  initials,
  src,
  className,
  ...restProps
}: AvatarProps) => {
  const [imgFailed, setImgFailed] = useState(false);
  const showImg = Boolean(src) && !imgFailed;
  return (
    <div
      className={avatarCss(
        {
          size,
          color: avatarColors[initials.charCodeAt(0) % avatarColors.length],
        },
        className
      )}
      {...restProps}
    >
      {showImg ? (
        <img
          alt={initials}
          className={css.img}
          onError={() => setImgFailed(true)}
          src={src}
        />
      ) : (
        initials
      )}
    </div>
  );
};
